import { resolveImageAlt } from '@eliadmin/core/src/utils/image-alt-utils';
import Image from 'next/image';

import type { IconsWithTextType } from '@eliadmin/core/src/api/general/types/general-types';

import { cn } from '@eliadmin/core/src/utils/style-utils';
import { Heading } from '../ui/heading';
import { Paragraph } from '../ui/paragraph';

export function Icons({ icons, className }: { icons: IconsWithTextType[]; className?: string }) {
  const filteredIcons = icons.filter(icon => icon.type?.includes('homepage'));

  return (
    <section className={cn('custom-section', className)}>
      <div
        className={cn(
          'custom-container',
          'grid grid-cols-1 gap-3 sm:grid-cols-2 md:gap-4 xl:grid-cols-4',
        )}
      >
        {filteredIcons.map(icon => (
          <IconCard key={icon.id} icon={icon} />
        ))}
      </div>
    </section>
  );
}

function IconCard({ icon }: { icon: IconsWithTextType }) {
  return (
    <div className="col-span-1 flex w-full items-center justify-start gap-3 rounded-[12px] bg-secondary-foreground p-3 md:gap-4">
      <div className="flex max-h-16 min-h-16 min-w-16 max-w-16 items-center justify-center rounded-[10px] bg-white">
        {icon.image?.url ? (
          <Image
            src={icon.image?.url}
            alt={resolveImageAlt(icon?.image, undefined)}
            width={32}
            height={32}
            className="object-contain object-center"
          />
        ) : null}
      </div>
      <div className="flex w-full flex-col items-start justify-start gap-[2px] md:gap-1">
        <Heading title={icon.name} tag="p" styleAs="h5" />
        <Paragraph className="w-full" innerHtml={icon.description} />
      </div>
    </div>
  );
}
